import {
  CategoryLandingPageFormattedTextSection,
  CategoryLandingPageProductListSection,
  CategoryLandingPageSection,
  CategoryLandingPageSliderSection,
  CategoryLandingPageSubcategoriesSection
} from '@services';

export const isFormattedText = (item: CategoryLandingPageSection): item is CategoryLandingPageFormattedTextSection => (
  Object.prototype.hasOwnProperty.call(item, 'formatted_text')
);

export const isProductList = (item: CategoryLandingPageSection): item is CategoryLandingPageProductListSection => (
  Object.prototype.hasOwnProperty.call(item, 'product_list')
);

export const isSubcategories = (item: CategoryLandingPageSection): item is CategoryLandingPageSubcategoriesSection => (
  Object.prototype.hasOwnProperty.call(item, 'subcategories')
);

export const isSlider = (item: CategoryLandingPageSection): item is CategoryLandingPageSliderSection => (
  Object.prototype.hasOwnProperty.call(item, 'slider')
);
